import { createEvent, deleteEvent, editEvent, getEventGraph, getEvents, getEventsGraphData } from './event.action';
export { eventsReducer } from './event.reducer';
export { watchEvents } from './event.saga';

export const eventActions = {
    /** Events */
    getEvents,
    getEventsGraphData,
    createEvent,
    editEvent,
    deleteEvent,
    getEventGraph,
    /** End */
};
